import * as React from 'react';
import { Tabs } from '@cian/ui-kit';
import { Header1 } from '@cian/ui-kit/typography';
import { IEcology } from '../../types/newbuilding/ecology';
import { EcologyCarousel } from '../EcologyCarousel';
import { Layout } from '../Layout';
import * as style from './Ecology.css';
import { trackParkTabClick } from './tracking';

export interface IEcologyProps {
  ecology: IEcology[];
}

export function Ecology({ ecology }: IEcologyProps) {
  const [activeTab, setActiveTab] = React.useState<number>(0);

  const onTabClick = React.useCallback(
    index => {
      setActiveTab(index);
      trackParkTabClick(ecology[index].title);
    },
    [ecology],
  );

  return (
    <Layout>
      <div className={style['nav_container']} data-nav-tab="ecology/Экология" id="ecology">
        <div className={style['container']}>
          <div className={style['header']}>
            <Header1 as={'h2'} fontWeight={'bold'}>
              Экология и парки
            </Header1>
          </div>
          {ecology.length > 1 && (
            <div className={style['tabs']}>
              <Tabs
                activeTab={String(activeTab)}
                onChange={onTabClick}
                tabs={ecology.map((item, index) => ({
                  value: String(index),
                  title: item.title,
                }))}
              />
            </div>
          )}
          <EcologyCarousel ecology={ecology[activeTab]} />
        </div>
      </div>
    </Layout>
  );
}
